import React from 'react';
import { email } from 'react-admin';
import EditSelectInput from '../../../../customFields/EditSelectInput';
import lineOfBusinessTypeChoices from '../constants/lineOfBusinessTypeChoices';
import EditField from '../../../../customFields/EditField';
import { countryChoices } from '../../../../constants/countries';
import languages from '../../../../constants/languages';

const LineOfBusinessProductInformation = ({
  showEdit,
}: {
  showEdit: boolean;
}) => (
  <>
    <EditField
      source="productInformation.name"
      label="Name"
      showEdit={showEdit}
    />
    <EditSelectInput
      source="productInformation.type"
      label="Type"
      choices={lineOfBusinessTypeChoices}
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.contactInfo.address.streetAddress"
      label="Street address"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.contactInfo.address.postalCode"
      label="Postal code"
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.contactInfo.address.city"
      label="City"
      showEdit={showEdit}
    />
    <EditSelectInput
      source="productInformation.contactInfo.address.country"
      label="Country"
      choices={countryChoices(languages.EN)}
      showEdit={showEdit}
    />
    <EditField
      source="productInformation.contactInfo.email"
      label="Email"
      showEdit={showEdit}
      validate={[email()]}
    />
    <EditField
      source="productInformation.contactInfo.phone"
      label="Phone"
      showEdit={showEdit}
    />
  </>
);

export default LineOfBusinessProductInformation;
